import cutter from "../Cutter";
import common from "../../../common";
import Dough from "../Dough";
import Cookie from "../Cookie";
import TutorialFinger from "../../../reusableModules/TutorialFinger";

export default class cuttingDough extends PIXI.Container {
    constructor() {
        super();
        this._tray = null;
        this._baseDough = null;
        this._cutDough = [];
        this._spacesRemaining = true;
        this._cutter = null;
        this._renderTextureBrush = null;
        this._dummyCookies = [];
        this._tutorialFinger = null;
        this._signals = {};
        this._signals.cuttingComplete = new P3.utils.MiniSignal();
        this._bindings = {};

        this._isMobile = PIXI.utils.isMobile.any;
    }

    init(dough, cutter) {
        this.createRenderTexture();
        this.createBaseDough(dough);
        this.createCutter(cutter);
        this.calcMinimumCookies();

        this._bindings.clickAnimationStart = this._cutter._signals.clickAnimationFinished.add(this.createCookie, this);

        this._testContainer = new PIXI.Container();
        this._testContainer.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._testContainer);

        this.createTutorial();
    }

    update() {
        if(this._tutorialFinger)
            this._tutorialFinger.update();
    }

    destroy(){
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};
    }

    createCutter(selectedCutter){
        this._cutter = new cutter(selectedCutter._currentNormalTexture, selectedCutter._renderTextureBrush, selectedCutter._cookieTexture);
        this._cutter.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._cutter);
    }

    createBaseDough(dough){
        this._baseDough = dough;
        this.addChild(this._baseDough);

        this._baseDough.interactive = true;
        this._baseDough.on('pointerdown', (event)=>{
            if(!this._cutter._animationPlaying){
                let radius = this._cutter.width * 0.84;
                let newCookie = {
                    x: event.data.getLocalPosition(this.parent).x,
                    y: event.data.getLocalPosition(this.parent).y,
                    r: radius * 0.45
                };

                for (const cookie of this._cutDough){
                    let cookieDimensions = {
                        x: cookie._maskSprite.x,
                        y: cookie._maskSprite.y,
                        r: radius * 0.45
                    };
                    if(this.sphereSphereCollisionCheck(newCookie, cookieDimensions)){
                        return;
                    }
                }

                if(!this.sphereBoxCollisionCheck(this._baseDough.doughDimensions, newCookie)){
                    return;
                }

                if(this._isMobile){
                    this._cutter.moveThenClick(event.data.getLocalPosition(this.parent));
                }else{
                    this._cutter.clickAnimation();
                }

                if(this._tutorialFinger)
                    this._tutorialFinger.turnOff();
            }
        });
        this._baseDough.on('pointermove', (event)=>{
            if(!this._cutter._animationPlaying){
                if(!this._isMobile){
                    this._cutter.x = event.data.getLocalPosition(this.parent).x;
                    this._cutter.y = event.data.getLocalPosition(this.parent).y;
                }
            }
            if(this._tutorialFinger)
                this._tutorialFinger.turnOff();
        });

        this._baseDough._bk = new PIXI.Sprite(P3.assets.texture("bg_table"));
        this._baseDough._bk.anchor.set(0.5);
        this._baseDough._bk.tint = 0xD8D8D8;
        this._baseDough._bk.x = common.STAGE_WIDTH * 0.5;
        this._baseDough._bk.y = common.STAGE_HEIGHT * 0.5;
        this._baseDough._bk.mask = this._renderTextureBrush._renderSprite;
        this.addChild(this._baseDough._bk);

        this._baseDough.doughDimensions = {
            x: this._baseDough.x - this._baseDough.view.width * 0.5 + 85,
            y: this._baseDough.y - this._baseDough.view.height * 0.5 + 65,
            h: this._baseDough.view.height - 140,
            w: this._baseDough.view.width - 175
        };
    }

    createRenderTexture(){
        this._renderTextureBrush = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._renderTextureBrush.anchor.set(0.5);

        this._renderTextureBrush._renderTexture = new PIXI.RenderTexture.create(common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this._renderTextureBrush._renderSprite = new PIXI.Sprite(this._renderTextureBrush._renderTexture);
        this.addChild(this._renderTextureBrush._renderSprite);
    }

    createCookie(renderTexture){
        this._renderTextureBrush.texture = renderTexture;
        this._renderTextureBrush.width = (renderTexture.width * 0.5) * 0.84;
        this._renderTextureBrush.height = (renderTexture.height * 0.5) * 0.84;
        this._renderTextureBrush.position.copy(this._cutter.position);
        common.renderer.render(this._renderTextureBrush, this._renderTextureBrush._renderTexture, false, null, false);

        let newCookie = new Cookie(common.renderer.generateTexture(this._baseDough), this._cutter, renderTexture);
        newCookie.position.set(-common.STAGE_WIDTH * 0.5, -common.STAGE_HEIGHT * 0.5);
        this._testContainer.addChild(newCookie);

        this._cutDough.push(newCookie);

        this.removeChild(this._cutter);
        this.addChild(this._cutter);

         if(this._spacesRemaining)
             this.checkAvailableSpace(newCookie);

        let curTex = common.cutCookieTextures.maskTexture.textureCacheIds[0];
        let textureString = curTex.slice(0, 17) + "overlay_" + curTex.slice(17,18);
        this._overlay = new PIXI.Sprite(P3.assets.texture(textureString));
        this._overlay.position.set(-common.STAGE_WIDTH * 0.5 + this._cutter.position.x, -common.STAGE_HEIGHT * 0.5 + this._cutter.position.y);
        this._overlay.anchor.set(0.5);
        this._overlay.width = (renderTexture.width * 0.5) * 0.84 - 10;
        this._overlay.height = (renderTexture.height * 0.5) * 0.84 - 10;
        this._testContainer.addChild(this._overlay);
    }

    createTray(){
        this._bindings.help.detach();
        if(this._tutorialFinger){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
        }


        this._baseDough._bk.visible = false;
        this._cutter.visible = false;
        let base = new P3.utils.TWEEN.Tween(this._baseDough, this.tweens)
            .to({
                alpha: 0
            }, 1500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .onComplete(()=>{
                this._renderTextureBrush.visible = false;
                this._renderTextureBrush._renderSprite.visible = false;
                new P3.utils.TWEEN.Tween(this._testContainer, this.tweens)
                    .to({
                        width: "+40",
                        height: "+40"
                    },300)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.In)
                    .start();
            });

        let tray = new PIXI.Sprite(P3.assets.texture('tray'));
        tray.anchor.set(0.5);
        tray.position.set(common.STAGE_WIDTH * 0.5, -tray.height);
        this.addChildAt(tray, 1);

        let cookieTween = new P3.utils.TWEEN.Tween(this._testContainer, this.tweens)
            .to({
                width: "-40",
                height: "-40"
            },300)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In);

        let trayTween = new P3.utils.TWEEN.Tween(tray, this.tweens)
            .to({
                y: common.STAGE_HEIGHT * 0.5
            }, 1500)
            .onComplete(()=>{
                cookieTween.start();
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let moveOut = new P3.utils.TWEEN.Tween(tray, this.tweens)
            .to({
                y: -tray.height
            },1500)
            .delay(500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .onComplete(()=>{
                new P3.utils.TWEEN.Tween(this, this.tweens)
                    .to({
                    }, 0)
                    .easing(P3.utils.Easing.Back2.Out)
                    .delay(250)
                    .onComplete(()=>{
                        this.parent.signals.next.dispatch();
                    })
                    .start();
            });

        let moveCookiesOut = new P3.utils.TWEEN.Tween(this._testContainer, this.tweens)
            .to({
                y: -tray.height
            },1500)
            .delay(500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out);

        cookieTween.chain(moveOut, moveCookiesOut);

        base.chain(trayTween);
        base.start();
    }

    calcMinimumCookies(){
        let container = new PIXI.Container();
        let dummyCookie = new PIXI.Sprite(P3.assets.texture('mask_dough_shape_5'));
        dummyCookie.anchor.set(0.5);
        dummyCookie.scale.set(0.4);
        container.addChild(dummyCookie);
        container.scale.set(0.84);

        let numPerRow = Math.floor((this._baseDough.width - 50) / container.width);
        let numOfCols = Math.floor((this._baseDough.height - 50) / container.height);

        let rowOffset = container.width;
        let colOffset = container.height;
        let startRow = this._baseDough.x - this._baseDough.width * 0.5 + container.width * 0.5 + 35;
        let startCol = this._baseDough.y - this._baseDough.height * 0.5 + container.height * 0.5 + 35 + 20;

        for (let cols = 0; cols < numOfCols; cols++) {
            for (let rows = 0; rows < numPerRow; rows++) {
                let graphic = new PIXI.Graphics();
                graphic.lineStyle(0);
                graphic.beginFill(0x000000, 0.5);
                graphic.drawCircle(startRow + 30, startCol, container.width * 0.5);
                graphic._hasObject = false;
                graphic._x = startRow + 20;
                graphic._y = startCol;
                startRow += rowOffset;
                // this.addChild(graphic);
                this._dummyCookies.push(graphic);
            }
            startCol += colOffset;
            startRow = this._baseDough.x - this._baseDough.width * 0.5 + container.width * 0.5 + 25;
        }
    }

    checkAvailableSpace(newCookie){
        this._spacesRemaining = true;

        for (let i = 0; i < this._dummyCookies.length; i++) {
            const dummyCookie = this._dummyCookies[i];
            if (dummyCookie._hasObject) {
                continue;
            }

            let dummyCookieDimensions = {
                x: dummyCookie._x,
                y: dummyCookie._y,
                r: dummyCookie.width * 0.5
            };
            for (let j = 0; j < this._cutDough.length; j++){
                const cookie = this._cutDough[j];
                let cookieDimensions = {
                    x: cookie._maskSprite.x,
                    y: cookie._maskSprite.y,
                    r: this._cutter.width * 0.5
                };
                if (this.sphereSphereCollisionCheck(dummyCookieDimensions, cookieDimensions)) {
                    dummyCookie._hasObject = true;
                    break;
                }
            }
        }

        let counter = 0;
        for (let i = 0; i < this._dummyCookies.length; i++){
            if (this._dummyCookies[i]._hasObject) {
                counter++;
            }
        }

        if(counter === this._dummyCookies.length - 1){
            this._signals.cuttingComplete.dispatch();
            this._spacesRemaining = false;
        }
    }

    sphereBoxCollisionCheck(rect, circle){
        let half = {
            x: rect.w / 2,
            y: rect.h / 2
        };

        let center = {
            x: circle.x - (rect.x + half.x),
            y: circle.y - (rect.y + half.y)
        };

        let side = {
            x: Math.abs(center.x) - half.x,
            y: Math.abs(center.y) - half.y
        };

        return side.x < -circle.r && side.y < -circle.r;
    }

    sphereSphereCollisionCheck(a, b) {
        let deltaXSquared = a.x - b.x;
        deltaXSquared *= deltaXSquared;
        let deltaYSquared = a.y - b.y;
        deltaYSquared *= deltaYSquared;

        let sumRadiiSquared = a.r + b.r;
        sumRadiiSquared *= sumRadiiSquared;

        return deltaXSquared + deltaYSquared <= sumRadiiSquared;
    }

    createTutorial(){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        this._tutorialFinger = new TutorialFinger({x:common.STAGE_WIDTH * 0.5 + 75, y: common.STAGE_HEIGHT * 0.5}, 10, -1);
        this.addChild(this._tutorialFinger);

        this._tutorialFinger.addDelay(1000);
        this._tutorialFinger.fade(true, 500, false);

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 + 300,
                y: common.STAGE_HEIGHT * 0.5 + 150
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 - 220,
                y: common.STAGE_HEIGHT * 0.5 - 150
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 + 75,
                y: common.STAGE_HEIGHT * 0.5 + 120
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.fade(false, 500, false);
        this._tutorialFinger.play();
    }
}